import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const categoriesAPI = createApi({
    reducerPath: "categoryAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllAvailableCategories: builder.query({
            query: () => {
                let apiUrl = `admin/data/category`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ['all_categories']
        }),
        getAllCategories: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/category?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["categories"],
        }),
        getSpecificCategoryDetails: builder.mutation({
            query: ({ id }) => {
                let apiUrl = `admin/category/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        createCategory: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/category",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["categories"],
        }),
        updateCategory: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/category`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["categories"],
        })
    })
});

export const { 
    useGetAllAvailableCategoriesQuery,
    useGetAllCategoriesMutation, 
    useGetSpecificCategoryDetailsMutation, 
    useCreateCategoryMutation, 
    useUpdateCategoryMutation 
} = categoriesAPI;

export default categoriesAPI;